import React from "react";
import {
  BaseForm,
  Input,
  Textarea,
  VALIDATION_TYPES,
} from "../../../components/Form";
import { getMessage } from "../../../lib/translator";
import API from "../../../lib/api";
import Loader from "../../../components/Loader";

class AnalyticsForm extends BaseForm {
  constructor(props) {
    super(props);
    this.state.values = {
      gaAccount: "",
      conversionTag: "",
    };
    this.state.formError = "";
    this.state.showLoader = false;
    this.hideLoader = this.hideLoader.bind(this);
    this.showLoader = this.showLoader.bind(this);
  }

  showLoader() {
    this.setState({
      showLoader: true,
    });
  }

  hideLoader() {
    this.setState({
      showLoader: false,
    });
  }

  componentDidMount() {
    this.setState({
      showLoader: true,
    });
    const api = new API({ url: "/config-service/config/analytics" });
    api
      .get()
      .then(
        (response) => {
          if (response.status === "SUCCESS") {
            const analytics = response.data.analytics;
            const values = {
              gaAccount: analytics.gaAccount,
              conversionTag: analytics.conversionTag,
            };
            this.setState({ values, showLoader: false });
          }
        },
        (error) => {
          this.setState({ formError: error.message, showLoader: false });
        }
      )
      .catch((error) => {
        console.error(error);
      });
  }

  handleSubmit(data) {
    const api = new API({ url: "/config-service/config" });
    let params = {};
    params["analytics"] = {};
    for (let field in data) {
      params["analytics"][field] = data[field];
    }
    return api
      .post(params)
      .then(
        (response) => {},
        (error) => {
          this.setState({ formError: error.message });
        }
      )
      .catch((error) => {
        console.error(error);
      });
  }

  onSubmit(data) {
    this.setState({
      submitting: true,
    });
    this.handleSubmit(data)
      .then(() => {
        this.setState({ submitting: false });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const { SubmitButton, CancelButton } = this.buttons;
    const { Form } = this.components;
    return (
      <div>
        {this.state.formError && (
          <div className="form-error">{this.state.formError}</div>
        )}
        {this.state.showLoader ? (
          <Loader />
        ) : (
          <Form>
            <Input
              label={getMessage("analytics.tracking.heading")}
              placeholder={getMessage("analytics.tracking.placeholder")}
              name="tracking_id"
              type="text"
              required
              {...this.generateStateMappers({
                stateKeys: ["gaAccount"],
                validationType: VALIDATION_TYPES.ONCHANGE,
              })}
              validationStrings={{
                valueMissing: getMessage("input.requiredMessage"),
                patternMismatch: getMessage("analytics.invalidTrackingId"),
              }}
            >
              {getMessage("extensions.analytics.gaAccount.description")}
            </Input>

            <Textarea
              label={getMessage("extensions.analytics.conversionTag.heading")}
              placeholder={getMessage("extensions.analytics.conversionTag.placeholder")}
              name="conversionTag"
              value={this.getState(["conversionTag"])}
              onChange={(value, error) => {
                this.updateState(["conversionTag"], value);
              }}
              onValidation={(error) => {
                this.registerValidation(["conversionTag"], error);
              }}
              validationStrings={{
                valueMissing: getMessage("input.requiredMessage"),
              }}
            >
              {getMessage("extensions.analytics.conversionTag.description")}
            </Textarea>
            <div className="form-buttons-container">
              <SubmitButton disabled={this.state.submitting}>
                {getMessage("analytics.submit.text")}
              </SubmitButton>
              <CancelButton disabled={this.state.submitting}>
                {getMessage("analytics.cancel.text")}
              </CancelButton>
            </div>
          </Form>
        )}
      </div>
    );
  }
}

export default AnalyticsForm;
